import React from 'react';

const PrivacyPolicy = () => {
  return (
    <main className="min-h-screen pt-24">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-light mb-6">Privacy Policy</h1>
        <div className="text-light/80 space-y-6">
          <p>
            Last updated: March 22, 2025
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Introduction</h2>
          <p>
            Eluno Consulting ("we," "our," or "us") respects your privacy and is committed to protecting your personal information. 
            This Privacy Policy describes how we collect, use, store, and disclose your personal information when you use our website.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Information We Collect</h2>
          <p>
            We may collect personal information such as your name, email address, phone number, company name, 
            and other information you provide when contacting us through our website.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">How We Use Your Information</h2>
          <p>
            We use your personal information to:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-2">
            <li>Respond to your inquiries and provide the services you request</li>
            <li>Communicate with you about our services, events, and updates</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Information Sharing</h2>
          <p>
            We do not sell, rent, or share your personal information with third parties except as described in this Privacy Policy.
            We may share your information with trusted service providers who assist us in operating our website and conducting our business.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information from unauthorized access,
            alteration, disclosure, or destruction.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Your Rights</h2>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, 
            including the right to access, correct, or delete your personal information.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new 
            Privacy Policy on this page and updating the "Last updated" date.
          </p>
          
          <h2 className="text-2xl font-semibold text-light mt-8 mb-4">Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="mt-2">
            Email: hello@eluno.consulting<br />
            Phone: (816) 678-5415
          </p>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;